<template>
<div class="topbar d-none d-md-block" :class="{ 'hidden-navbar': !showNavbar }" >
    <div class="container">
        <div class="d-flex align-items-center justify-content-between py-2">
            <div class="left d-flex align-items-center"> 
                <p class="mb-0 mr-3 d-flex align-items-center justify-content-start">
				<b-navbar-brand href="/" v-b-toggle.sidebar-1>
					<b-img :src="$root.MEDIAPATH+'images/logo.png'" class="logoTop"></b-img>
				</b-navbar-brand></p> 
                <!--<p class="mb-0 mr-3 d-flex align-items-center justify-content-start"> <b-icon icon="telephone-inbound"></b-icon> <b-link href="tel:+91 8920670756"><i class="fa fa-phone mr-1 mt-1" aria-hidden="true" style="font-size: 15px;"></i> +91 8920670756</b-link> </p>   -->     </div>
				<div class="right d-flex align-items-center">
                <p class="mb-0 mr-2"><b-img src="../../assets/home/trending.png" style="width: 15px;"></b-img><b-link href="/videos"> Trending @Alluraa </b-link>  </p><p class="mb-0 mr-4"> </p><p class="mb-0 mr-2"><b-link href="/marketing/influencer"> Join as Influencer </b-link></p>
               
            </div>
            <div class="right d-flex align-items-center">
                <p class="mb-0 mr-2"><strong>15% Off</strong> use code 'AllURS15' | </p>
                <p class="mb-0 mr-2"><b-link href="/marketing/seller">Sell on Alluraa</b-link> | </p>
                <p class="mb-0 mr-2"><b-link href="/faq">Help Center</b-link></p>
            </div>
        </div>
    </div>
</div>
</template>

<script>
const OFFSET = 60
export default {
	data () {
		return {
		  showNavbar: true,
		  lastScrollPosition: 0,
		  scrollValue: 0
		}
	},
	mounted () {
    this.lastScrollPosition = window.pageYOffset
    window.addEventListener('scroll', this.onScroll)
    const viewportMeta = document.createElement('meta')
    viewportMeta.name = 'viewport'
    viewportMeta.content = 'width=device-width, initial-scale=1'
    document.head.appendChild(viewportMeta)
  },
  beforeDestroy () {
    window.removeEventListener('scroll', this.onScroll)
  },
  methods:{
    onScroll () {
      if (window.pageYOffset < 0) {
        return
      }
      if (Math.abs(window.pageYOffset - this.lastScrollPosition) < OFFSET) {
        return
      }
      this.showNavbar = window.pageYOffset < this.lastScrollPosition
      this.lastScrollPosition = window.pageYOffset
    }
  }

}
</script>

<style>
    .hidden-navbar {
	  display:none !important;
	  box-shadow: none;
	  transform: translate3d(0, -100%, 0);
	}
</style>